import { GetPublicOverviewResponse } from '@orbit/api-types'
import { buildOverviewData } from './buildOverviewData'
import { TripOverviewData, TripOverviewSection } from './types'

/**
 * Normalize the aggregated Shared-trip endpoint into the same `TripOverviewData`
 * the member page renders from. Exposure is gated server-side; as
 * defense-in-depth this adapter re-checks the money flag before mapping
 * pay ups.
 */
export const buildPublicTripOverviewData = (response: GetPublicOverviewResponse): TripOverviewData =>
	buildOverviewData(response, {
		// Detail shows the returned slice, so the count must equal it; a teaser
		// instead advertises the true total from the wire.
		filesCount: response.sections.files.shared
			? response.sections.files.files.length
			: response.sections.files.count,
		// Defense-in-depth: a malformed payload carrying pay ups alongside
		// `shared: false` must still produce an anonymous tile.
		payUps: response.sections.expenses.shared ? (response.sections.expenses.payUps ?? []) : [],
	})

/** Per-section share flags for `resolveTileState`. Note the `expenses → money` remap. */
export const buildPublicShareFlags = (
	response: GetPublicOverviewResponse,
): Record<TripOverviewSection, boolean> => ({
	itinerary: response.sections.itinerary.shared,
	ideas: response.sections.ideas.shared,
	accommodations: response.sections.accommodations.shared,
	flights: response.sections.flights.shared,
	files: response.sections.files.shared,
	money: response.sections.expenses.shared,
})
